var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 705.21 153.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_21-3);}.cls-2{fill:url(#Gradiente_sem_nome_21);}.cls-3{fill:none;stroke:#000;stroke-miterlimit:10;}.cls-4{fill:#fff;}.cls-5{fill:url(#Gradiente_sem_nome_21-2);}.cls-6{fill:url(#Gradiente_sem_nome_21-4);}.cls-7{fill:url(#Gradiente_sem_nome_28);}.cls-8{fill:url(#Gradiente_sem_nome_21-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_21",
    x1: 79.44,
    y1: 54.1,
    x2: 193.15,
    y2: 54.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4c773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a7c883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#689690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#639288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#588775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#507f66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_21-2",
    x1: 55.44,
    y1: 93.27,
    x2: 169.14,
    y2: 93.27,
    xlinkHref: "#Gradiente_sem_nome_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_21-3",
    x1: 31.43,
    y1: 132.43,
    x2: 145.14,
    y2: 132.43,
    xlinkHref: "#Gradiente_sem_nome_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_28",
    x1: 52.28,
    y1: 21.89,
    x2: 165.99,
    y2: 21.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4c773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#a7c883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#689690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#639288"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#588775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#507f66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_21-4",
    x1: 28.27,
    y1: 61.05,
    x2: 141.98,
    y2: 61.05,
    xlinkHref: "#Gradiente_sem_nome_21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_21-5",
    x1: 4.27,
    y1: 100.22,
    x2: 117.98,
    y2: 100.22,
    xlinkHref: "#Gradiente_sem_nome_21"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -71.14,
    y: -92.92,
    width: 840.46,
    height: 340.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M204.74,89.49c0-4.71.72-8.84,2.17-12.38,1.45-3.54,3.35-6.48,5.71-8.84s5.07-4.14,8.13-5.36c3.06-1.21,6.21-1.82,9.45-1.82,7.54,0,13.5,2.31,17.88,6.92,4.38,4.61,6.57,11.4,6.57,20.36,0,.88-.04,1.84-.1,2.88-.07,1.05-.13,1.97-.2,2.78h-34.15c.34,3.1,1.78,5.56,4.34,7.38,2.56,1.82,5.99,2.73,10.31,2.73,2.76,0,5.47-.25,8.13-.76,2.66-.51,4.83-1.13,6.52-1.87l2.02,12.22c-.81.4-1.89.81-3.23,1.21-1.35.4-2.85.76-4.5,1.06-1.65.3-3.42.56-5.3.76-1.89.2-3.77.3-5.66.3-4.78,0-8.94-.71-12.48-2.12-3.54-1.41-6.47-3.35-8.79-5.81s-4.04-5.37-5.15-8.74c-1.11-3.37-1.67-7-1.67-10.91ZM240.1,83.73c-.07-1.28-.29-2.53-.66-3.74-.37-1.21-.94-2.29-1.72-3.23-.78-.94-1.75-1.72-2.93-2.32-1.18-.61-2.65-.91-4.4-.91s-3.13.29-4.34.86c-1.21.57-2.22,1.33-3.03,2.27-.81.94-1.43,2.04-1.87,3.28-.44,1.25-.76,2.51-.96,3.79h19.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.27,64.33c2.56-.74,5.86-1.43,9.9-2.07,4.04-.64,8.29-.96,12.73-.96s8.27.59,11.26,1.77c3,1.18,5.37,2.85,7.12,5,1.75,2.16,2.99,4.71,3.74,7.68s1.11,6.26,1.11,9.9v30.01h-15.06v-28.19c0-4.85-.64-8.29-1.92-10.31-1.28-2.02-3.67-3.03-7.17-3.03-1.08,0-2.22.05-3.44.15-1.21.1-2.29.22-3.23.35v41.02h-15.06v-51.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M323.24,89.49c0-4.71.72-8.84,2.17-12.38,1.45-3.54,3.35-6.48,5.71-8.84s5.07-4.14,8.13-5.36,6.21-1.82,9.45-1.82c7.54,0,13.5,2.31,17.88,6.92s6.57,11.4,6.57,20.36c0,.88-.04,1.84-.1,2.88-.07,1.05-.13,1.97-.2,2.78h-34.15c.34,3.1,1.78,5.56,4.34,7.38,2.56,1.82,5.99,2.73,10.31,2.73,2.76,0,5.47-.25,8.13-.76,2.66-.51,4.83-1.13,6.52-1.87l2.02,12.22c-.81.4-1.89.81-3.23,1.21-1.35.4-2.85.76-4.5,1.06-1.65.3-3.42.56-5.3.76-1.89.2-3.77.3-5.66.3-4.78,0-8.94-.71-12.48-2.12-3.54-1.41-6.47-3.35-8.79-5.81s-4.04-5.37-5.15-8.74c-1.11-3.37-1.67-7-1.67-10.91ZM358.6,83.73c-.07-1.28-.29-2.53-.66-3.74-.37-1.21-.94-2.29-1.72-3.23-.78-.94-1.75-1.72-2.93-2.32-1.18-.61-2.65-.91-4.4-.91s-3.13.29-4.34.86c-1.21.57-2.22,1.33-3.03,2.27-.81.94-1.43,2.04-1.87,3.28-.44,1.25-.76,2.51-.96,3.79h19.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M416.8,75.85c-1.35-.34-2.93-.69-4.75-1.06-1.82-.37-3.77-.56-5.86-.56-.94,0-2.07.09-3.38.25-1.31.17-2.31.35-2.98.56v40.61h-15.06v-50.31c2.69-.94,5.88-1.83,9.55-2.68,3.67-.84,7.76-1.26,12.28-1.26.81,0,1.78.05,2.93.15,1.14.1,2.29.24,3.44.4,1.14.17,2.29.37,3.44.61,1.14.24,2.12.52,2.93.86l-2.53,12.43Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M429.02,65.24c1.95-.54,4.5-1.14,7.63-1.82,3.13-.67,7.19-1.01,12.17-1.01,6.6,0,11.38,1.92,14.35,5.76.34-.27.99-.72,1.97-1.36.98-.64,2.2-1.3,3.69-1.97,1.48-.67,3.21-1.25,5.2-1.72,1.99-.47,4.19-.71,6.62-.71,3.97,0,7.19.59,9.65,1.77,2.46,1.18,4.36,2.83,5.71,4.95,1.35,2.12,2.26,4.66,2.73,7.63.47,2.96.71,6.2.71,9.7v29.2h-6.57v-27.08c0-3.44-.15-6.42-.45-8.94-.3-2.53-.91-4.61-1.82-6.26-.91-1.65-2.2-2.9-3.89-3.74-1.69-.84-3.88-1.26-6.57-1.26-2.02,0-3.86.19-5.51.56-1.65.37-3.08.83-4.29,1.36-1.21.54-2.21,1.08-2.98,1.62-.78.54-1.33.94-1.67,1.21.61,1.75,1.06,3.72,1.36,5.91.3,2.19.45,4.5.45,6.92v29.7h-6.57v-27.08c0-3.44-.15-6.42-.45-8.94-.3-2.53-.93-4.61-1.87-6.26-.94-1.65-2.27-2.9-3.99-3.74-1.72-.84-3.99-1.26-6.82-1.26-3.16,0-5.84.17-8.03.51-2.19.34-3.59.64-4.19.91v45.87h-6.57v-50.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M532.07,62.21c3.44,0,6.35.49,8.74,1.47,2.39.98,4.33,2.32,5.81,4.04,1.48,1.72,2.56,3.76,3.23,6.11.67,2.36,1.01,4.92,1.01,7.68v32.93c-.67.2-1.65.42-2.93.66-1.28.24-2.76.49-4.45.76-1.68.27-3.55.49-5.61.66-2.05.17-4.16.25-6.32.25-2.76,0-5.3-.3-7.63-.91-2.32-.61-4.34-1.57-6.06-2.88-1.72-1.31-3.07-3-4.04-5.05-.98-2.05-1.47-4.56-1.47-7.53s.54-5.25,1.62-7.28c1.08-2.02,2.59-3.69,4.55-5,1.95-1.31,4.28-2.27,6.97-2.88,2.69-.61,5.62-.91,8.79-.91.94,0,1.93.05,2.98.15,1.04.1,2.05.24,3.03.4.98.17,1.82.34,2.53.51.71.17,1.19.32,1.47.45v-3.23c0-1.82-.14-3.59-.4-5.3-.27-1.72-.86-3.27-1.77-4.65-.91-1.38-2.19-2.49-3.84-3.33-1.65-.84-3.82-1.26-6.52-1.26-3.84,0-6.7.27-8.59.81-1.89.54-3.27.98-4.14,1.31l-.91-5.76c1.14-.54,2.91-1.04,5.3-1.52,2.39-.47,5.27-.71,8.64-.71ZM532.68,110.91c2.56,0,4.8-.08,6.72-.25,1.92-.17,3.55-.39,4.9-.66v-18.39c-.74-.34-1.92-.69-3.54-1.06-1.62-.37-3.84-.56-6.67-.56-1.62,0-3.3.12-5.05.35-1.75.24-3.37.74-4.85,1.52-1.48.78-2.7,1.84-3.64,3.18-.94,1.35-1.41,3.13-1.41,5.36,0,1.95.32,3.6.96,4.95.64,1.35,1.55,2.42,2.73,3.23,1.18.81,2.59,1.4,4.24,1.77,1.65.37,3.52.56,5.61.56Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M573.79,63.42h20.81v5.56h-20.81v27.78c0,2.96.25,5.37.76,7.22.51,1.85,1.23,3.28,2.17,4.29s2.09,1.69,3.44,2.02c1.35.34,2.83.51,4.45.51,2.76,0,4.98-.32,6.67-.96,1.68-.64,3-1.23,3.94-1.77l1.62,5.45c-.94.61-2.59,1.3-4.95,2.07-2.36.77-4.92,1.16-7.68,1.16-3.23,0-5.95-.42-8.13-1.26-2.19-.84-3.94-2.12-5.25-3.84s-2.24-3.86-2.78-6.42c-.54-2.56-.81-5.59-.81-9.09v-48.09l6.57-1.21v16.57Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M628.35,116.77c-4.04,0-7.61-.64-10.71-1.92-3.1-1.28-5.67-3.11-7.73-5.51-2.06-2.39-3.62-5.25-4.7-8.59-1.08-3.33-1.62-7.02-1.62-11.06s.56-7.85,1.67-11.21c1.11-3.37,2.71-6.26,4.8-8.69,2.09-2.43,4.61-4.29,7.58-5.61,2.96-1.31,6.3-1.97,10-1.97,2.83,0,5.47.24,7.93.71,2.46.47,4.36,1.08,5.71,1.82l-1.72,5.66c-1.35-.67-2.87-1.21-4.55-1.62-1.68-.4-3.94-.61-6.77-.61-5.79,0-10.19,1.87-13.19,5.61s-4.5,9.04-4.5,15.91c0,3.1.34,5.94,1.01,8.54.67,2.59,1.77,4.82,3.28,6.67,1.52,1.85,3.47,3.3,5.86,4.34,2.39,1.05,5.3,1.57,8.74,1.57,2.83,0,5.2-.32,7.12-.96,1.92-.64,3.32-1.2,4.19-1.67l1.41,5.66c-1.21.67-3.12,1.33-5.71,1.97-2.59.64-5.3.96-8.13.96Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M653.2,115.65V38.47l6.57-1.21v27.68c2.15-.81,4.34-1.43,6.57-1.87,2.22-.44,4.45-.66,6.67-.66,4.04,0,7.41.57,10.1,1.72,2.69,1.15,4.85,2.78,6.47,4.9,1.62,2.12,2.74,4.66,3.38,7.63.64,2.96.96,6.23.96,9.8v29.2h-6.57v-27.08c0-3.7-.25-6.84-.76-9.4-.51-2.56-1.35-4.65-2.53-6.26-1.18-1.62-2.75-2.78-4.7-3.49s-4.41-1.06-7.38-1.06c-1.14,0-2.37.1-3.69.3s-2.54.42-3.69.66c-1.14.24-2.17.49-3.08.76-.91.27-1.5.47-1.77.61v44.96h-6.57Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "174.83 70.21 79.44 67.05 99.03 37.99 193.15 41.15 174.83 70.21"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "150.83 109.38 55.44 106.22 75.02 77.16 169.14 80.32 150.83 109.38"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.82 148.54 31.43 145.38 51.02 116.33 145.14 119.48 126.82 148.54"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "147.67 37.99 52.28 34.84 71.86 5.78 165.99 8.94 147.67 37.99"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "123.66 77.16 28.27 74 47.86 44.94 141.98 48.1 123.66 77.16"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "99.66 116.33 4.27 113.17 23.85 84.11 117.98 87.27 99.66 116.33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBranco);
export default __webpack_public_path__ + "static/media/logoBranco.153d1752e08cc1df8631a29723dcb48d.svg";
export { ForwardRef as ReactComponent };